import { Component, Input, OnInit } from '@angular/core';
import { Pill } from '../../models/pill';

@Component({
  selector: 'app-pill-box',
  templateUrl: './pill-box.component.html',
  styleUrls: ['./pill-box.component.scss']
})
export class PillBoxComponent implements OnInit {
  @Input() pills: Pill[];
  @Input() editable: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }
}
